// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

export const environment = {
  production: false,
  baseURL: 'https://app.ifs-eu.theloops.ai/v1',
  /** Cube.js API base URL; requests to /load will show in Network tab */
  cubejsURL: 'https://app.ifs-eu.theloops.ai/cubejs-api/v1',

  /** Default app ID for API paths (from /teams/authorize) */
  appId: '2',
  envName: 'ifs',
  /** Base URL for this app (Teams tab contentUrl/websiteUrl); used when building for each env */
  agentHomepageBaseUrl: 'https://agenthomepage.ifs.eu.theloops.ai',
  reactAppBaseUrl: 'https://#tenantId#.ifs.eu.theloops.ai'
};
